export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAdding: (state) => state.isAdding,
  list: (state) => state.list,
  paging: (state) => state.paging,
  cursor: (state) =>
    state.paging && state.paging.next_cursor ? state.paging.next_cursor : null,
};
